import React from "react";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

const CardOverTimeTable = ({ title, children, currentValue, updateValue, listValues, downloadButton }) => {
    return (
        <div className=" card w-full bg-white ">
            <div className="title-card">
                <div className="flex flex-row justify-between items-end">
                    <div>
                        <h2>{title}</h2>
                    </div>

                    <div className="flex flex-row justify-between items-end gap-4 ">
                        {downloadButton}

                        <span>
                            <Dropdown
                                menu={{ items: listValues, onClick: (data) => updateValue(data.key) }}
                                className="flex items-center justify-center w-[62px] h-[22px] text-xs "
                            >
                                <Button>
                                    <Space>
                                        {currentValue}
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                        </span>
                    </div>
                </div>
            </div>

            <div className=" overflow-x-auto h-full w-full">{children}</div>
        </div>
    );
};

export default CardOverTimeTable;
